import $ from 'jquery';
import View from 'mixins/view';
import CommentFactory from '@ui/comments/CommentFactory';

export default class AbstractComment extends View {
    constructor(model) {
        super(model);
        const html = `<article data-id="${model.get('id')}"
                               id="comment${model.get('id')}" class="user-comment">
                      </article>`;
        this.setRootEl($(html));

        const refresh = event => {
            if (this.model.get('id') === Number(event.detail.id)) {
                if (event.detail.model) {
                    this.model.update(event.detail.model);
                }
                this.repaint();
            }
        };
        this.getRootEl().on('RefreshComment', refresh.bind(this));
    }
    getCommentView() {
        return this.comment;
    }
    render() {
        this.model.removeEvents();
        this.comment = CommentFactory.create(this.model);

        if (this.comment !== null) {
            this.comment.setRootEl(this.rootEl);
        } else {
            this.rootEl.empty().removeClass();
        }
    }
    repaint() {
        const parentNode = (this.comment || {}).parentNode;

        this.render();
        if (this.comment === null) {
            return;
        }
        if (parentNode !== void 0) {
            this.comment.parentNode = parentNode;
        }
        this.comment.render();
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/abstract-comment.js